import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** flowing wind, breathing. Decorative line icon; always pair with a visible text label. */
export function BreathIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M3 8.5h8.5a2.5 2.5 0 1 0-2.4-3.2" />
      <path d="M3 12.5h13.5a2.5 2.5 0 1 1-2.4 3.2" />
      <path d="M3 16.5h5.5" />
    </IconSvg>
  )
}
